module.exports = __webpack_public_path__ + "static/img/focusCode.57935d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/footer/focusCode.png
// module id = rUM0
// module chunks = 22